import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
const Segment = ({ left, width }) => {
    return _jsx("div", { style: { left: `${left}%`, width: `${width}%` }, className: cn("absolute h-full bg-primary-9", left === 0 && "rounded-l") });
};
export default Segment;
